import { render, staticRenderFns } from "./document-row-toolbar.vue?vue&type=template&id=67fc030f"
import script from "./document-row-toolbar.vue?vue&type=script&lang=js"
export * from "./document-row-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports